export default function PendingApproval() {
  return (
    <div className="flex h-full items-center justify-center bg-slate-100">
      <div className="w-full max-w-md rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
        <h1 className="mb-2 text-xl font-semibold text-slate-900">Pending approval</h1>
        <p className="text-sm text-slate-600">
          Your account is awaiting approval from an administrator. You'll get access the next time
          you sign in after approval.
        </p>
        <form method="post" action="/api/v1/auth/google/logout" className="mt-6">
          <button
            type="submit"
            className="rounded border border-slate-300 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
          >
            Sign out
          </button>
        </form>
      </div>
    </div>
  );
}
